import axios from "../../axios";

const createReport = async (report_type, query = "", ignore_queries = "") => {
  console.log(query, "query", ignore_queries, "ignore_queries");
  try {
    query = query?.charAt(0) === '&' ? query.slice(1) : query;
    ignore_queries = !query && ignore_queries?.charAt(0) === '&' ? ignore_queries.slice(1) : ignore_queries;
    const response = await axios.get(`/reports/${report_type}?${query}${ignore_queries}`);
    return response.data;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export { createReport };